// Dynamic-Injector

DynamicInjector = function () {
  this._landingData = undefined;
  this._symbols = [];
  this._bounceSymbols = [];
  this._postSymbols = [];
  this._stateData = {};

  //////////////////////////////////////
  // New
  this._mainReelBandData = [];
  this._symbolSelecter = undefined;
  this._readyToLand = false;
  this._insertingResults = false;
  this._aboveSymbols = [];
  this._landingSymbols = [];
  this._belowSymbols = [];
  this._symbolsUntilResult = 0;
  this._reelID = 0;
  this._nudgeReel = false;
  this._windowSize = 0;
  this._preAppertureSize = 0;
  this._postAppertureSize = 0;
  this._fullAppertureSize = 0;
  this._symbolsInjectedThisSpin = 0;
  this._currentInjectorMode = undefined;
  this._blockSymbols = [];
  //////////////////////////////////////

  this.setWeightingsAndRules = function (injectorData) {
    this._symbolSelecter = new SymbolSelecter();
    this._symbolSelecter.setData(this._reelID, injectorData);
  };

  this.prepareInjector = function (
    reelId,
    nudgeReel,
    windowSize,
    preAppertureSize,
    postAppertureSize,
    injectorData
  ) {
    this._reelID = reelId;
    this._nudgeReel = nudgeReel;
    this._windowSize = windowSize;
    this._preAppertureSize = preAppertureSize;
    this._postAppertureSize = postAppertureSize;
    this._fullAppertureSize = windowSize + preAppertureSize + postAppertureSize;
    this._aboveSymbols = [];
    this._landingSymbols = [];
    this._belowSymbols = [];
    this._mainReelBandData = [];
    this.setWeightingsAndRules(injectorData);
  };

  this.spinStarting = function () {
    this._insertingResults = false;
    this._symbolsInjectedThisSpin = 0;
  };

  // This function should just grab the next symbol to display at the top of the reel
  // No rules detection need here as this has already been done
  this.injectNextSymbol = function () {
    let nextSymbol = -1;

    if (this.getBandLength() === 0) {
      this.pickNextSymbols();
    }
    const symObj = this._mainReelBandData.shift();
    nextSymbol = symObj.symId;

    if (this._symbolsUntilResult > 0) {
      this._symbolsUntilResult--;
    }

    this._symbolsInjectedThisSpin++;

    if (nextSymbol === -1) {
      throw new Error('Injector unable to provide valid symbol!');
    }

    return nextSymbol;
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // HELPERS
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////
  this.pickNextSymbols = function (index = -1) {
    let reelbandData = undefined;
    if (index !== -1 && this._insertingResults) {
      reelbandData = {
        index: index,
        reelband: this._mainReelBandData,
      };
    }

    const symList = this._symbolSelecter.pickSymbols(reelbandData);

    for (let i = 0; i < symList.length; i++) {
      let symType = 'normal';
      if (this._blockSymbols.includes(symList[i])) {
        symType = 'block';
      }
      if (index === -1) {
        this.insertSymbol(symList[i], symType, false);
      } else {
        this.insertSymbol(symList[i], symType, false, index + i);
      }
    }
  };

  this.getSymAtIndex = function (index) {
    return this._mainReelBandData[index].symId;
  };

  this.getBandLength = function () {
    return this._mainReelBandData.length;
  };

  this.insertBlankSymbolAtStart = function () {
    let sym = {
      symId: 15,
      locked: false,
      type: 'padding',
    };
    this._mainReelBandData.unshift(sym);
  };

  this.insertBlankSymbol = function () {
    let sym = {
      symId: -1,
      locked: false,
      type: 'blank',
    };
    this._mainReelBandData.push(sym);
  };

  this.insertSymbol = function (symId, type, locked, index = -1) {
    let sym = {
      symId: symId,
      type: type,
      locked: locked,
    };
    if (index === -1) {
      this._mainReelBandData.push(sym);
    } else if (index >= 0 && index < this.getBandLength()) {
      if (!this._mainReelBandData[index].locked) {
        this._mainReelBandData[index].symId = symId;
        this._mainReelBandData[index].type = type;
        this._mainReelBandData[index].locked = locked;
      }
    }
  };

  this.countRepeatingSymbols = function (startIndex) {
    if (startIndex < 0 || startIndex >= this.getBandLength()) {
      return 0;
    }
    const target = this.getSymAtIndex(startIndex);
    let count = 1;
    // Count backwards
    for (let i = startIndex - 1; i >= 0; i--) {
      if (this.getSymAtIndex(i) === target) {
        count++;
      } else {
        break;
      }
    }
    // Count forwards
    for (let i = startIndex + 1; i < this.getBandLength(); i++) {
      if (this.getSymAtIndex(i) === target) {
        count++;
      } else {
        break;
      }
    }
    return count;
  };

  this.isSymbolInRange = function (symId, index, range) {
    const start = Math.max(0, index - range);
    const end = Math.min(this.getBandLength() - 1, index + range);

    for (let i = start; i <= end; i++) {
      if (this.getSymAtIndex(i) === symId) {
        return true;
      }
    }
    return false;
  };
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////

  this.setLandingSymbols = function (
    landingSymbols,
    aboveSymbols = [],
    belowSymbols = []
  ) {
    this._aboveSymbols = aboveSymbols;
    this._landingSymbols = landingSymbols;
    this._belowSymbols = belowSymbols;
  };

  this.readyToLand = function () {
    return this._readyToLand;
  };

  this.reachedLandingSymbols = function () {
    if (this.readyToLand && this._symbolsUntilResult === 0) {
      return true;
    } else {
      return false;
    }
  };

  this.clearLandingSymbols = function () {
    this._aboveSymbols = [];
    this._landingSymbols = [];
    this._belowSymbols = [];
  };

  this.insertLandingSymbols = function (symsToSpin) {
    //const additionalSymbols = Math.floor(Math.random() * 30) + 1;
    const additionalSymbols = 0;
    const symbolsLeftToSpin =
      symsToSpin - this._symbolsInjectedThisSpin + additionalSymbols;
    this._symbolsUntilResult = symbolsLeftToSpin;

    // Symbols inserted in reverse
    const resultStartPos =
      symbolsLeftToSpin - (this._preAppertureSize + this._windowSize);
    const aboveSymbols = this._aboveSymbols.length;
    const belowSymbols = this._belowSymbols.length;

    let blankSymbolsToAdd =
      resultStartPos - aboveSymbols - this.getBandLength();

    for (let i = 0; i < blankSymbolsToAdd; i++) {
      this.insertBlankSymbol();
    }
    const startIndex = this.getBandLength();
    // All symbols need to be added in reverse order
    // Below symbols need to be added first...
    if (belowSymbols) {
      for (let i = this._belowSymbols.length - 1; i >= 0; i--) {
        this.insertSymbol(this._belowSymbols[i], 'below', true);
      }
    }
    // Add the result window here
    for (let i = this._landingSymbols.length - 1; i >= 0; i--) {
      this.insertSymbol(this._landingSymbols[i], 'result', true);
    }
    // ...Above symbols need to be added after
    if (aboveSymbols) {
      for (let i = this._aboveSymbols.length - 1; i >= 0; i--) {
        this.insertSymbol(this._aboveSymbols[i], 'above', true);
      }
    }
    const endIndex = this.getBandLength() - 1;
    this._insertingResults = true;

    this.completePartialLandSymbolBlocks(startIndex, endIndex);
    this.fillBand();
    this.updateLastSeenCountWithResults();

    this._readyToLand = true;

    return additionalSymbols;
  };

  this.updateLastSeenCountWithResults = function () {
    // This assumes that only result window, above/below
    // and additional block symbols will be 'locked'.
    // This will ensure that symbols picked after the results
    // window area will maintain correct symbol gaps
    this._insertingResults = false;

    for (let i = 0; i < this.getBandLength(); i++) {
      if (this._mainReelBandData[i].locked) {
        const symId = this._mainReelBandData[i].id;
        this._symbolSelecter.updateLastSeenCount(symId);
      }
    }
  };

  this.addPaddingSymbols = function (paddingSymbols) {
    for (let i = 0; i < paddingSymbols; i++) {
      this.insertBlankSymbolAtStart();
      this._symbolsUntilResult++;
    }
  };

  this.setReadyToLand = function (ready) {
    this._readyToLand = ready;
  };

  this.completePartialLandSymbolBlocks = function (startIndex, endIndex) {
    let startCount = 0;
    let endCount = 0;
    let fullBlock = false;
    const fullLockedSize = endIndex - startIndex + 1;
    const startSym = this.getSymAtIndex(startIndex);
    const endSym = this.getSymAtIndex(endIndex);

    if (this._blockSymbols.includes(startSym)) {
      startCount = this.countRepeatingSymbols(startIndex);
    }
    if (this._blockSymbols.includes(endSym)) {
      endCount = this.countRepeatingSymbols(endIndex);
    }

    if (startCount === endCount && startCount === fullLockedSize) {
      fullBlock = true;
    }

    // Jamie - maybe add system for dealing with full result blocks
    if (!fullBlock) {
      if (startCount) {
        const blockSize = this._symbolSelecter.getSymbolCount(startSym);
        const symsToAdd = Math.max(0, blockSize - startCount);
        for (let i = 0; i < symsToAdd; i++) {
          let index = startIndex - (i + 1);
          this.insertSymbol(startSym, 'block', true, index);
        }
      }
      if (endCount) {
        const blockSize = this._symbolSelecter.getSymbolCount(endSym);
        const symsToAdd = Math.max(0, blockSize - endCount);
        for (let i = 0; i < symsToAdd; i++) {
          this.insertSymbol(endSym, 'block', true);
        }
      }
    }
  };

  this.fillBand = function () {
    for (let i = 0; i < this.getBandLength(); i++) {
      if (this.getSymAtIndex(i) === -1) {
        this.pickNextSymbols(i);
      }
    }
    //this.debugOutputReelband();
  };

  this.debugOutputReelband = function () {
    let band = [];
    for (let i = 0; i < this.getBandLength(); i++) {
      band.push(this.getSymAtIndex(i));
    }
    console.log('Reel: ' + this._reelID + ' - ' + JSON.stringify(band));
  };

  this.setInjectorMode = function (injectorMode) {
    this._currentInjectorMode = injectorMode;
    this._symbolSelecter.setInjectorMode(injectorMode);
    this._blockSymbols = this._symbolSelecter.getBlockSymbols();
  };

  this.insertAnticipationSymbols = function (anticipationSymbols) {
    const symId = anticipationSymbols.symId;
    const symCount = anticipationSymbols.count;
    const minGap = anticipationSymbols.minGap;
    let validIndexList = [];

    for (let i = minGap - 1; i < this.getBandLength(); i++) {
      if (
        !this._mainReelBandData[i].locked &&
        this._mainReelBandData[i].type !== 'block'
      ) {
        // List containing the valid positions to place anticipation symbol
        // Excludes the initial min gap (in case injector has just picked it)
        // And any of the result window symbols
        const symInRange = this.isSymbolInRange(symId, i, minGap - 1);
        if (!symInRange) {
          validIndexList.push(i);
        }
      }
    }

    for (let i = 0; i < symCount; i++) {
      let listLength = validIndexList.length;
      if (listLength) {
        let index = Math.floor(Math.random() * listLength);
        let mainIndex = validIndexList[index];
        this.insertSymbol(symId, 'anticipation', false, mainIndex);
        const min = mainIndex - minGap;
        const max = mainIndex + minGap;

        for (let j = validIndexList.length - 1; j >= 0; j--) {
          if (validIndexList[j] > min && validIndexList[j] < max) {
            validIndexList.splice(j, 1);
          }
        }
      }
    }
  };

  this.saveState = function () {
    this._stateData = {};
    let keys = Object.getOwnPropertyNames(this);
    for (let i = 0; i < keys.length; i++) {
      let name = keys[i];
      let type = typeof this[name];
      let isCallback = name.includes('callback') || name.includes('Callback');

      if (type !== 'function' && name !== 'base' && !isCallback) {
        if (checkForDefined(this[name])) {
          this._stateData[keys[i]] = JSON.parse(JSON.stringify(this[name]));
        } else {
          this._stateData[keys[i]] = undefined;
        }
      }
    }

    // Add the local scope variables above
    this._stateData._landingData = checkForDefined(_landingData)
      ? JSON.parse(JSON.stringify(_landingData))
      : undefined;
    this._stateData._symbols = checkForDefined(_symbols)
      ? JSON.parse(JSON.stringify(_symbols))
      : undefined;
    this._stateData._bounceSymbols = checkForDefined(_bounceSymbols)
      ? JSON.parse(JSON.stringify(_bounceSymbols))
      : undefined;
    this._stateData._postSymbols = checkForDefined(_postSymbols)
      ? JSON.parse(JSON.stringify(_postSymbols))
      : undefined;
    this._stateData._stateData = checkForDefined(_stateData)
      ? JSON.parse(JSON.stringify(_stateData))
      : undefined;
  };

  this.restoreState = function () {
    let keys = Object.keys(_stateData);
    for (let i = 0; i < keys.length; i++) {
      let name = keys[i];
      if (checkForDefined(_stateData[name])) {
        this[name] = JSON.parse(JSON.stringify(_stateData[name]));
      } else {
        this[name] = undefined;
      }
    }

    this._stateData = {};
  };

  Object.defineProperty(this, 'remainingSymbols', {
    get: function () {
      return this._symbols.length;
    },
  });

  Object.defineProperty(this, 'symbolsLastDrawn', {
    get: function () {
      return this.base.symbolsLastDrawn;
    },
    set: function (symbols) {
      let keys = Object.keys(symbols);
      for (let i = 0; i < keys.length; ++i) {
        this.base.symbolsLastDrawn[keys[i]] = symbols[keys[i]];
      }
    },
  });

  Object.defineProperty(this, 'requiredSymbols', {
    get: function () {
      return this.base.requiredSymbols;
    },
    set: function (symbols) {
      this.base.requiredSymbols = symbols;
    },
  });

  Object.defineProperty(this, 'bounceSymbols', {
    get: function () {
      return this._bounceSymbols;
    },
    set: function (symbols) {
      this._bounceSymbols = symbols;
    },
  });
  Object.defineProperty(this, 'postSymbols', {
    get: function () {
      return this._postSymbols;
    },
    set: function (symbols) {
      this._postSymbols = symbols;
    },
  });
  Object.defineProperty(this, 'hasLandingSymbols', {
    get: function () {
      return (
        this._landingData !== undefined &&
        this._landingData.landingSymbols !== undefined
      );
    },
  });
};
